// Phase 4B visual-only sculpture pass.
// Semantic/runtime contracts stay in phase4-world-personalization.js; this file
// only protects Kimi sightlines and human-scale placement of exterior supports.

function apply() {
  const scene = window.__qa?.scene;
  if (!scene || document.documentElement.dataset.cbwPhase4b !== 'ready') {
    requestAnimationFrame(apply);
    return;
  }
  const get=(id)=>scene.getObjectByName(`cbw:media:${id}`);
  const billboard=get('world.altea.media.billboard.01');
  const totem=get('world.altea.media.totem.01');
  const mupi1=get('world.altea.media.mupi.01');
  const mupi2=get('world.altea.media.mupi.02');
  const mupi3=get('world.altea.media.mupi.03');
  const screen1=get('world.altea.media.screen.01');
  const screen2=get('world.altea.media.screen.02');

  // West promenade — clear of palms and the Sea House property sightline.
  if (billboard) {
    billboard.position.set(-13.2, 0, 7.2);
    billboard.rotation.y = -0.08;
    billboard.scale.setScalar(0.88);
  }
  // Orientation support — pedestrian scale, detached from facade architecture.
  if (totem) {
    totem.position.set(-4.2, 0.03, 15.2);
    totem.rotation.y = 0.08;
    totem.scale.setScalar(0.74);
  }
  // Three distinct street-furniture placements; avoid a repeated straight line.
  if (mupi1) { mupi1.position.set(-1.9,0.01,7.7); mupi1.rotation.y=-0.14; mupi1.scale.setScalar(0.82); }
  if (mupi2) { mupi2.position.set(6.3,0.01,8.9); mupi2.rotation.y=-0.46; mupi2.scale.setScalar(0.82); }
  if (mupi3) { mupi3.position.set(-10.0,0.01,13.4); mupi3.rotation.y=0.20; mupi3.scale.setScalar(0.82); }
  // Digital screens read as exterior displays, not replacement building masses.
  if (screen1) { screen1.position.set(11.7,0.02,12.6); screen1.rotation.y=-0.78; screen1.scale.setScalar(0.82); }
  if (screen2) { screen2.position.set(-15.2,0.02,12.8); screen2.rotation.y=0.18; screen2.scale.setScalar(0.82); }

  document.documentElement.dataset.cbwPhase4Visual = 'polished-7-supports';
}
apply();
